export enum FlowSteps {
  Auth = 1,
  SelectPlan = 2,
  UploadPictures = 3,
  WaitForProcessing = 4,
  ProcessingReady = 5,
}
